export enum BillingType {
  TimeAndMaterial = 'TIME_AND_MATERIAL',
  FirmFixedPrice = 'FIRM_FIXED_PRICE',
  CostPlusFixedFee = 'COST_PLUS_FIXED_FEE',
  CostPlusAwardFee = 'COST_PLUS_AWARD_FEE',
  CostPlusIncentiveFee = 'COST_PLUS_INCENTIVE_FEE',
  FirmFixedPriceIncentive = 'FIRM_FIXED_PRICE_INCENTIVE',
  LaborHour = 'LABOR_HOUR',
  FirmFixedPriceLOE = 'FIRM_FIXED_PRICE_LOE',
  CostPlusFixedFeeLOE = 'COST_PLUS_FIXED_FEE_LOE',
  FixedUnitPrice = 'FIXED_UNIT_PRICE'
}

export namespace BillingType {
  export function isFirmFixedPrice(billingType: BillingType): boolean {
    return billingType == BillingType.FirmFixedPrice || billingType == BillingType.FirmFixedPriceIncentive || billingType == BillingType.FirmFixedPriceLOE;
  }
  export function isCostBillingType(billingType: BillingType): boolean {
    return billingType == BillingType.CostPlusFixedFee || billingType == BillingType.CostPlusAwardFee || billingType == BillingType.CostPlusIncentiveFee || billingType == BillingType.CostPlusFixedFeeLOE;
  }

  export function isTimeAndMaterial(billingType: BillingType): boolean {
    return billingType == BillingType.TimeAndMaterial || billingType == BillingType.LaborHour;
  }

  export function isFixedUnitPrice(billingType: BillingType): boolean {
    return billingType == BillingType.FixedUnitPrice;
  }

  export function isValidForCostRetainage(billingType: BillingType): boolean {
    return billingType == BillingType.CostPlusFixedFee || billingType == BillingType.CostPlusFixedFeeLOE;
  }
}